import { ResultOf } from "@graphql-typed-document-node/core";
import { graphql } from "@/gql";

export type WorkOrdersStatusCount = ResultOf<
  typeof workOrderStatusCountQuery
>["workOrderStatusCount"];

export const workOrderStatusCountQuery = graphql(`
  query WorkOrderStatusCount($supplier_id: ID) {
    workOrderStatusCount(supplier_id: $supplier_id) {
      count
      status
    }
  }
`);

export type WorkOrderRegionalCount = ResultOf<
  typeof workOrderRegionalCountsQuery
>["workOrderRegionalCounts"][number];

export const workOrderRegionalCountsQuery = graphql(`
  query WorkOrderRegionalCounts($start: DateTimeTz!, $end: DateTimeTz!) {
    workOrderRegionalCounts(start: $start, end: $end) {
      region
      pending_count
      won_count
      cancelled_count
    }
  }
`);
